/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
var rpc_admin_image_pb = require('../../rpc/admin/image_pb.js');
goog.object.extend(proto, rpc_admin_image_pb);
goog.exportSymbol('proto.admin.GetSportsSouthProductRequest', null, global);
goog.exportSymbol('proto.admin.SportsSouthProduct', null, global);
goog.exportSymbol('proto.admin.SportsSouthProduct.AttributeValuePair', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SportsSouthProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.SportsSouthProduct.repeatedFields_, null);
};
goog.inherits(proto.admin.SportsSouthProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SportsSouthProduct.displayName = 'proto.admin.SportsSouthProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SportsSouthProduct.AttributeValuePair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.SportsSouthProduct.AttributeValuePair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SportsSouthProduct.AttributeValuePair.displayName = 'proto.admin.SportsSouthProduct.AttributeValuePair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GetSportsSouthProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.GetSportsSouthProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GetSportsSouthProductRequest.displayName = 'proto.admin.GetSportsSouthProductRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.SportsSouthProduct.repeatedFields_ = [39,40];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SportsSouthProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SportsSouthProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SportsSouthProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SportsSouthProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemno: jspb.Message.getFieldWithDefault(msg, 1, 0),
    idesc: jspb.Message.getFieldWithDefault(msg, 2, ""),
    imfseq: jspb.Message.getFieldWithDefault(msg, 3, 0),
    imfgno: jspb.Message.getFieldWithDefault(msg, 4, 0),
    cseq: jspb.Message.getFieldWithDefault(msg, 5, 0),
    itype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    shdesc: jspb.Message.getFieldWithDefault(msg, 7, ""),
    uom: jspb.Message.getFieldWithDefault(msg, 8, ""),
    prc1: +jspb.Message.getFieldWithDefault(msg, 9, 0.0),
    cprc: +jspb.Message.getFieldWithDefault(msg, 10, 0.0),
    qtyoh: jspb.Message.getFieldWithDefault(msg, 11, 0),
    wtpbx: +jspb.Message.getFieldWithDefault(msg, 12, 0.0),
    itupc: jspb.Message.getFieldWithDefault(msg, 13, ""),
    mfgino: jspb.Message.getFieldWithDefault(msg, 14, ""),
    scnam1: jspb.Message.getFieldWithDefault(msg, 15, ""),
    scnam2: jspb.Message.getFieldWithDefault(msg, 16, ""),
    catcd: jspb.Message.getFieldWithDefault(msg, 17, ""),
    mfprtyp: jspb.Message.getFieldWithDefault(msg, 18, ""),
    mfprc: +jspb.Message.getFieldWithDefault(msg, 19, 0.0),
    catid: jspb.Message.getFieldWithDefault(msg, 20, 0),
    txtref: jspb.Message.getFieldWithDefault(msg, 21, 0),
    picref: jspb.Message.getFieldWithDefault(msg, 22, 0),
    itbrdno: jspb.Message.getFieldWithDefault(msg, 23, 0),
    imodel: jspb.Message.getFieldWithDefault(msg, 24, ""),
    ipurpose: jspb.Message.getFieldWithDefault(msg, 25, ""),
    series: jspb.Message.getFieldWithDefault(msg, 26, ""),
    length: +jspb.Message.getFieldWithDefault(msg, 27, 0.0),
    height: +jspb.Message.getFieldWithDefault(msg, 28, 0.0),
    width: +jspb.Message.getFieldWithDefault(msg, 29, 0.0),
    hazair: jspb.Message.getFieldWithDefault(msg, 30, ""),
    hazgrnd: jspb.Message.getFieldWithDefault(msg, 31, ""),
    chgdte: jspb.Message.getFieldWithDefault(msg, 32, ""),
    loaddt: jspb.Message.getFieldWithDefault(msg, 33, ""),
    brand: jspb.Message.getFieldWithDefault(msg, 34, ""),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 35, ""),
    department: jspb.Message.getFieldWithDefault(msg, 36, ""),
    category: jspb.Message.getFieldWithDefault(msg, 37, ""),
    text: jspb.Message.getFieldWithDefault(msg, 38, ""),
    attributesList: jspb.Message.toObjectList(msg.getAttributesList(),
    proto.admin.SportsSouthProduct.AttributeValuePair.toObject, includeInstance),
    imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    rpc_admin_image_pb.Image.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SportsSouthProduct}
 */
proto.admin.SportsSouthProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SportsSouthProduct;
  return proto.admin.SportsSouthProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SportsSouthProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SportsSouthProduct}
 */
proto.admin.SportsSouthProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemno(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdesc(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setImfseq(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setImfgno(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCseq(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setShdesc(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUom(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrc1(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCprc(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQtyoh(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWtpbx(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setItupc(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMfgino(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setScnam1(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setScnam2(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCatcd(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMfprtyp(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMfprc(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCatid(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTxtref(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPicref(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItbrdno(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setImodel(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setIpurpose(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeries(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLength(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeight(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWidth(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setHazair(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setHazgrnd(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setChgdte(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoaddt(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturer(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 39:
      var value = new proto.admin.SportsSouthProduct.AttributeValuePair;
      reader.readMessage(value,proto.admin.SportsSouthProduct.AttributeValuePair.deserializeBinaryFromReader);
      msg.addAttributes(value);
      break;
    case 40:
      var value = new rpc_admin_image_pb.Image;
      reader.readMessage(value,rpc_admin_image_pb.Image.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SportsSouthProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SportsSouthProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SportsSouthProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SportsSouthProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemno();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIdesc();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getImfseq();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getImfgno();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCseq();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getItype();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getShdesc();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUom();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrc1();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getCprc();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getQtyoh();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getWtpbx();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getItupc();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getMfgino();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getScnam1();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getScnam2();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCatcd();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMfprtyp();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMfprc();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getCatid();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getTxtref();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getPicref();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getItbrdno();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getImodel();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getIpurpose();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getSeries();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getLength();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getHazair();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getHazgrnd();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getChgdte();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getLoaddt();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getManufacturer();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      39,
      f,
      proto.admin.SportsSouthProduct.AttributeValuePair.serializeBinaryToWriter
    );
  }
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      40,
      f,
      rpc_admin_image_pb.Image.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SportsSouthProduct.AttributeValuePair.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SportsSouthProduct.AttributeValuePair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SportsSouthProduct.AttributeValuePair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SportsSouthProduct.AttributeValuePair.toObject = function(includeInstance, msg) {
  var f, obj = {
    attribute: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SportsSouthProduct.AttributeValuePair}
 */
proto.admin.SportsSouthProduct.AttributeValuePair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SportsSouthProduct.AttributeValuePair;
  return proto.admin.SportsSouthProduct.AttributeValuePair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SportsSouthProduct.AttributeValuePair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SportsSouthProduct.AttributeValuePair}
 */
proto.admin.SportsSouthProduct.AttributeValuePair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttribute(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SportsSouthProduct.AttributeValuePair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SportsSouthProduct.AttributeValuePair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SportsSouthProduct.AttributeValuePair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SportsSouthProduct.AttributeValuePair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttribute();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string attribute = 1;
 * @return {string}
 */
proto.admin.SportsSouthProduct.AttributeValuePair.prototype.getAttribute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.AttributeValuePair.prototype.setAttribute = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.admin.SportsSouthProduct.AttributeValuePair.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.AttributeValuePair.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 itemno = 1;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getItemno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setItemno = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string idesc = 2;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getIdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setIdesc = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 imfseq = 3;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getImfseq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setImfseq = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 imfgno = 4;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getImfgno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setImfgno = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 cseq = 5;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getCseq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setCseq = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 itype = 6;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getItype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setItype = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string shdesc = 7;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getShdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setShdesc = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string uom = 8;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getUom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setUom = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional double prc1 = 9;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getPrc1 = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setPrc1 = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double cprc = 10;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getCprc = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 10, 0.0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setCprc = function(value) {
  jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional int32 qtyoh = 11;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getQtyoh = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setQtyoh = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional double wtpbx = 12;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getWtpbx = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 12, 0.0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setWtpbx = function(value) {
  jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string itupc = 13;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getItupc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setItupc = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string mfgino = 14;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getMfgino = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setMfgino = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string scnam1 = 15;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getScnam1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setScnam1 = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string scnam2 = 16;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getScnam2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setScnam2 = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string catcd = 17;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getCatcd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setCatcd = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string mfprtyp = 18;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getMfprtyp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setMfprtyp = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional double mfprc = 19;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getMfprc = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 19, 0.0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setMfprc = function(value) {
  jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional int32 catid = 20;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getCatid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setCatid = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int32 txtref = 21;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getTxtref = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setTxtref = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int32 picref = 22;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getPicref = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setPicref = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int32 itbrdno = 23;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getItbrdno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setItbrdno = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string imodel = 24;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getImodel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setImodel = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string ipurpose = 25;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getIpurpose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setIpurpose = function(value) {
  jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string series = 26;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getSeries = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setSeries = function(value) {
  jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional double length = 27;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getLength = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 27, 0.0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setLength = function(value) {
  jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional double height = 28;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getHeight = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 28, 0.0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setHeight = function(value) {
  jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional double width = 29;
 * @return {number}
 */
proto.admin.SportsSouthProduct.prototype.getWidth = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 29, 0.0));
};


/** @param {number} value */
proto.admin.SportsSouthProduct.prototype.setWidth = function(value) {
  jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional string hazair = 30;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getHazair = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setHazair = function(value) {
  jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string hazgrnd = 31;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getHazgrnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setHazgrnd = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string chgdte = 32;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getChgdte = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setChgdte = function(value) {
  jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string loaddt = 33;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getLoaddt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setLoaddt = function(value) {
  jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string brand = 34;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setBrand = function(value) {
  jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string manufacturer = 35;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getManufacturer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setManufacturer = function(value) {
  jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string department = 36;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setDepartment = function(value) {
  jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string category = 37;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setCategory = function(value) {
  jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string text = 38;
 * @return {string}
 */
proto.admin.SportsSouthProduct.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/** @param {string} value */
proto.admin.SportsSouthProduct.prototype.setText = function(value) {
  jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * repeated AttributeValuePair attributes = 39;
 * @return {!Array<!proto.admin.SportsSouthProduct.AttributeValuePair>}
 */
proto.admin.SportsSouthProduct.prototype.getAttributesList = function() {
  return /** @type{!Array<!proto.admin.SportsSouthProduct.AttributeValuePair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.SportsSouthProduct.AttributeValuePair, 39));
};


/** @param {!Array<!proto.admin.SportsSouthProduct.AttributeValuePair>} value */
proto.admin.SportsSouthProduct.prototype.setAttributesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 39, value);
};


/**
 * @param {!proto.admin.SportsSouthProduct.AttributeValuePair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.SportsSouthProduct.AttributeValuePair}
 */
proto.admin.SportsSouthProduct.prototype.addAttributes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 39, opt_value, proto.admin.SportsSouthProduct.AttributeValuePair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.SportsSouthProduct.prototype.clearAttributesList = function() {
  this.setAttributesList([]);
};


/**
 * repeated Image images = 40;
 * @return {!Array<!proto.admin.Image>}
 */
proto.admin.SportsSouthProduct.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.admin.Image>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_image_pb.Image, 40));
};


/** @param {!Array<!proto.admin.Image>} value */
proto.admin.SportsSouthProduct.prototype.setImagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 40, value);
};


/**
 * @param {!proto.admin.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Image}
 */
proto.admin.SportsSouthProduct.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 40, opt_value, proto.admin.Image, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.SportsSouthProduct.prototype.clearImagesList = function() {
  this.setImagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GetSportsSouthProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GetSportsSouthProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GetSportsSouthProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetSportsSouthProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemno: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GetSportsSouthProductRequest}
 */
proto.admin.GetSportsSouthProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GetSportsSouthProductRequest;
  return proto.admin.GetSportsSouthProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GetSportsSouthProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GetSportsSouthProductRequest}
 */
proto.admin.GetSportsSouthProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GetSportsSouthProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GetSportsSouthProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GetSportsSouthProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetSportsSouthProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemno();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 itemno = 1;
 * @return {number}
 */
proto.admin.GetSportsSouthProductRequest.prototype.getItemno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.admin.GetSportsSouthProductRequest.prototype.setItemno = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


goog.object.extend(exports, proto.admin);
